var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pie"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.detail.length)?_c('div',{staticStyle:{"width":"100%","height":"300px"},attrs:{"id":_vm.id}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }